// Helper functions to manage modal visibility
export const hideModal = (id) => {
  const modal_el = document.querySelector("#" + id);
  const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

  if (modal_obj == null) {
    return;
  }

  modal_obj.hide();
};

export const showModal = (id) => {
  const modal_el = document.querySelector("#" + id);

  if (!modal_el) {
    console.warn(`Modal element with id "${id}" not found.`);
    return;
  }

  let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

  if (modal_obj == null) {
    modal_obj = new window.bootstrap.Modal(modal_el, {
      backdrop: "static",
    });
  }

  modal_obj.show();
};
